import React from 'react';
import { Text, themeVars } from '@eds-web/react';

export const CircleProgress: React.FC<{ maxValue: number; value: number }> = ({
    maxValue,
    value
}) => {
    const radius = 30;
    const circumference = 2 * Math.PI * radius;
    const percentage = (value / maxValue) * 100;
    const offset = circumference - (percentage / 100) * circumference;
    const strokeWidth = 3;
    return (
        <div style={{ position: 'relative', width: '90px', height: '90px' }}>
            <svg width="90" height="90">
                <circle
                    stroke={themeVars.color.transparent.light['015']}
                    fill="transparent"
                    strokeWidth={strokeWidth}
                    r={radius}
                    cx="45"
                    cy="45"
                />
                <circle
                    stroke={themeVars.color.palette.green['300']}
                    fill="transparent"
                    strokeWidth={strokeWidth}
                    r={radius}
                    cx="45"
                    cy="45"
                    strokeDasharray={circumference}
                    strokeDashoffset={offset}
                    style={{ transition: 'stroke-dashoffset 0.5s ease-in-out' }}
                    transform={'rotate(-90 45 45)'}
                />
            </svg>
            <Text
                variant={'uiLGBold'}
                style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)'
                }}
            >
                {value}/{maxValue}
            </Text>
        </div>
    );
};
